import { useEffect, useState } from 'react';

import { useTrackVideoAskView } from '#src/app/pages/actions/shared/hooks';

import { useVideosComponentContext } from '../../../../../../context';

type Result = ModelHookResult<{
	shouldAnimateEntrance: boolean;
}>;

/**
 * The entrance flag and the page-view event - unlike `VideoFirstAsk`, this screen has no location to
 * resolve and no camera permission to request from here (the record CTA advances to the recorder,
 * which asks).
 */
export function useStaticFacesAsk(): Result {
	useTrackVideoAskView();

	const {
		data: { hasPlayedAskIntro },
		actions: { setHasPlayedAskIntro },
	} = useVideosComponentContext();

	// Captured at first render, same reasoning as `useVideoFirstAsk`: flipping the context flag below
	// must not cancel a cascade already running, and a re-entry mid-flow has to land everything in place.
	const [shouldAnimateEntrance] = useState(() => !hasPlayedAskIntro);

	useEffect(() => {
		setHasPlayedAskIntro(true);
	}, [setHasPlayedAskIntro]);

	return { data: { shouldAnimateEntrance } };
}
